var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 39,
    viewBox: "0 0 32 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6096 20.5493C26.5609 15.6506 30.6044 13.3011 30.7852 13.1824C28.5127 9.85978 24.9723 9.40387 23.7122 9.35199C20.7016 9.04621 17.8349 11.1253 16.3076 11.1253C14.7834 11.1253 12.4237 9.3968 9.92719 9.44081C6.64305 9.48955 3.61595 11.3509 1.92593 14.2908C-1.48477 20.2074 1.05341 28.9759 4.37685 33.7779C6.00162 36.125 7.93925 38.7662 10.4814 38.6695C12.9315 38.5728 13.8559 37.0848 16.8177 37.0848C19.7796 37.0848 20.6112 38.6695 23.2029 38.62C25.8377 38.572 27.5081 36.228 29.1195 33.8714C30.9848 31.1446 31.7528 28.5042 31.7984 28.3706C31.741 28.3439 26.6623 26.3984 26.6096 20.5493Z",
    fill: "#0174EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.74 6.17446C23.0881 4.5379 24.0015 2.26384 23.7531 0C21.8076 0.0786055 19.4526 1.29306 18.0557 2.92806C16.8043 4.37911 15.7102 6.68933 16.0034 8.91229C18.1737 9.08051 20.3872 7.80789 21.74 6.17446Z",
    fill: "#0174EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.99f4da8c9e3f71416dc27f87c5be18a2.svg";
export { ForwardRef as ReactComponent };